// Library entry resolver — given a `(libraryId, libraryVersion)` ref
// and the bundled set of `libraryEntries` from the public wizard-config
// response, returns the resolved archetype + merged config. Overrides
// from the ref are applied on top of the library entry's config.
export function resolveBlock(ref, libraryEntries, archetypes) {
    const entry = libraryEntries.find((e) => e.id === ref.libraryId && e.version === ref.libraryVersion);
    if (!entry) {
        return {
            ref,
            reason: 'library_entry_missing',
            detail: `block_library entry not found: ${ref.libraryId}@${ref.libraryVersion}`,
        };
    }
    const archetype = archetypes.get(entry.archetype);
    if (!archetype) {
        return {
            ref,
            reason: 'archetype_missing',
            detail: `archetype not registered in code: ${entry.archetype} (referenced by ${entry.id}@${entry.version})`,
        };
    }
    return {
        ref,
        entry,
        archetype,
        config: { ...entry.config, ...(ref.overrides ?? {}) },
    };
}
